import React from 'react';
import { Controller } from 'react-hook-form';
import { RadioButton } from 'primereact/radiobutton';
import { classNames } from 'primereact/utils';

const EzControlledRadioButton = (props) => {
  const { control, name, value, customClassNames, rules, onChange } = props;

  return (
    <Controller
      name={name}
      rules={rules}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <RadioButton
            inputId={`${name}_${value}`}
            name={name}
            value={value}
            checked={field.value === value}
            onChange={(e) => {
              if (onChange) {
                onChange(e);
              }
              field.onChange(e.value);
            }}
            className={classNames({
              'p-invalid': fieldState.invalid,
            }, customClassNames)}
          />
        );
      }}
    />
  );
};

EzControlledRadioButton.defaultProps = {
  customClassNames: '',
};

export default EzControlledRadioButton;